const spellsLVL5 = [
  {
    index: 'antilife-shell',
    name: 'Antilife Shell',
    url: '/api/spells/antilife-shell',
    shortdesc: 'Creates a barrier around you that blocks out living creatures.',
    desc: [
      'A shimmering barrier extends out from you in a 10-foot radius and moves with you, remaining centered on you and hedging out creatures other than undead and constructs. The barrier lasts for the duration.',
      'The barrier prevents an affected creature from passing or reaching through. An affected creature can cast spells or make attacks with ranged or reach weapons through the barrier.',
      'If you move so that an affected creature is forced to pass through the barrier, the spell ends.',
    ],
    range: 'Self',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Up to 1 hour',
    concentration: true,
    casting_time: '1 action',
    level: 5,
    area_of_effect: {
      type: 'sphere',
      size: 10,
    },
  },
  {
    index: 'awaken',
    name: 'Awaken',
    url: '/api/spells/awaken',
    shortdesc:
      'Makes a plant or dumb beast sentient for 30 days or until the caster or their companions harms it.',
    desc: [
      "After spending the casting time tracing magical pathways within a precious gemstone, you touch a Huge or smaller beast or plant. The target must have either no Intelligence score or an Intelligence of 3 or less. The target gains an Intelligence of 10. The target also gains the ability to speak one language you know. If the target is a plant, it gains the ability to move its limbs, roots, vines, creepers, and so forth, and it gains senses similar to a human's. Your DM chooses statistics appropriate for the awakened plant, such as the statistics for the awakened shrub or the awakened tree.",
      'The awakened beast or plant is charmed by you for 30 days or until you or your companions do anything harmful to it. When the charmed condition ends, the awakened creature chooses whether to remain friendly to you, based on how you treated it while it was charmed.',
    ],
    range: 'Touch',
    components: ['V', 'S', 'M'],
    material: 'An agate worth at least 1,000 gp, which the spell consumes.',
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '8 hours',
    level: 5,
  },
  {
    index: 'commune-with-nature',
    name: 'Commune With Nature',
    url: '/api/spells/commune-with-nature',
    shortdesc:
      'You become one with nature and learn about the lay of the land for up to 3 miles away.',
    desc: [
      "You briefly become one with nature and gain knowledge of the surrounding territory. In the outdoors, the spell gives you knowledge of the land within 3 miles of you. In caves and other natural underground settings, the radius is limited to 300 feet. The spell doesn't function where nature has been replaced by construction, such as in dungeons and towns.",
      'You instantly gain knowledge of up to three facts of your choice about any of the following subjects as they relate to the area:',
      'Terrain and bodies of water',
      'Prevalent plants, minerals, animals, or peoples',
      'Powerful celestials, fey, fiends, elementals, or undead',
      'Influence from other planes of existence',
      'Buildings',
      'For example, you could determine the location of powerful undead in the area, the location of major sources of safe drinking water, and the location of any nearby towns.',
    ],
    range: 'Self',
    components: ['V', 'S'],
    ritual: true,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 minute',
    level: 5,
  },
  {
    index: 'conjure-elemental',
    name: 'Conjure Elemental',
    url: '/api/spells/conjure-elemental',
    shortdesc: 'Call an elemental to appear in the area.',
    desc: [
      'You call forth an elemental servant. Choose an area of air, earth, fire, or water that fills a 10-foot cube within range. An elemental of challenge rating 5 or lower appropriate to the area you chose appears in an unoccupied space within 10 feet of it. For example, a fire elemental emerges from a bonfire, and an earth elemental rises up from the ground. The elemental disappears when it drops to 0 hit points or when the spell ends.',
      "The elemental is friendly to you and your companions for the duration. Roll initiative for the elemental, which has its own turns. It obeys any verbal commands that you issue to it (no action required by you). If you don't issue any commands to the elemental, it defends itself from hostile creatures but otherwise takes no actions.",
      "If your concentration is broken, the elemental doesn't disappear. Instead, you lose control of the elemental, it becomes hostile toward you and your companions, and it might attack. An uncontrolled elemental can't be dismissed by you, and it disappears 1 hour after you summoned it.",
      "The DM has the elemental's statistics.",
    ],
    higher_level: [
      'When you cast this spell using a spell slot of 6th level or higher, the challenge rating increases by 1 for each slot level above 5th.',
    ],
    range: '90 feet',
    components: ['V', 'S', 'M'],
    material:
      'Burning incense for air, soft clay for earth, sulfur and phosphorus for fire, or water and sand for water.',
    ritual: false,
    duration: 'Up to 1 hour',
    concentration: true,
    casting_time: '1 minute',
    level: 5,
    area_of_effect: {
      type: 'cube',
      size: 10,
    },
  },
  {
    index: 'contagion',
    name: 'Contagion',
    url: '/api/spells/contagion',
    shortdesc:
      'Melee spell attack that causes one of the following diseases on hit:',
    desc: [
      'Your touch inflicts disease. Make a melee spell attack against a creature within your reach. On a hit, you afflict the creature with a disease of your choice from any of the ones described below.',
      "At the end of each of the target's turns, it must make a constitution saving throw. After failing three of these saving throws, the disease's effects last for the duration, and the creature stops making these saves. After succeeding on three of these saving throws, the creature recovers from the disease, and the spell ends.",
      "Since this spell induces a natural disease in its target, any effect that removes a disease or otherwise ameliorates a disease's effects apply to it.",
      'Blinding Sickness.',
      "Pain grips the creature's mind, and its eyes turn milky white. The creature has disadvantage on wisdom checks and wisdom saving throws and is blinded.",
      'Filth Fever.',
      "A raging fever sweeps through the creature's body. The creature has disadvantage on strength checks, strength saving throws, and attack rolls that use Strength.",
      'Flesh Rot.',
      "The creature's flesh decays. The creature has disadvantage on Charisma checks and vulnerability to all damage.",
      'Mindfire.',
      "The creature's mind becomes feverish. The creature has disadvantage on intelligence checks and intelligence saving throws, and the creature behaves as if under the effects of the confusion spell during combat.",
      'Seizure.',
      'The creature is overcome with shaking. The creature has disadvantage on dexterity checks, dexterity saving throws, and attack rolls that use Dexterity.',
      'Slimy Doom.',
      'The creature begins to bleed uncontrollably. The creature has disadvantage on constitution checks and constitution saving throws. In addition, whenever the creature takes damage, it is stunned until the end of its next turn.',
    ],
    range: 'Touch',
    components: ['V', 'S'],
    ritual: false,
    duration: '7 days',
    concentration: false,
    casting_time: '1 action',
    level: 5,
    attack_type: 'melee',
    dc: {
      dc_type: {
        index: 'con',
        name: 'CON',
        url: '/api/ability-scores/con',
      },
      dc_success: 'other',
      desc: 'After succeeding on three of these saving throws, the creature recovers from the disease, and the spell ends.',
    },
  },
  {
    index: 'geas',
    name: 'Geas',
    url: '/api/spells/geas',
    shortdesc: 'A target becomes charmed and must obey a command you give. ',
    desc: [
      "You place a magical command on a creature that you can see within range, forcing it to carry out some service or refrain from some action or course of activity as you decide. If the creature can understand you, it must succeed on a wisdom saving throw or become charmed by you for the duration. While the creature is charmed by you, it takes 5d10 psychic damage each time it acts in a manner directly counter to your instructions, but no more than once each day. A creature that can't understand you is unaffected by the spell.",
      'You can issue any command you choose, short of an activity that would result in certain death. Should you issue a suicidal command, the spell ends.',
      'You can end the spell early by using an action to dismiss it. A remove curse, greater restoration, or wish spell also ends it.',
    ],
    higher_level: [
      'When you cast this spell using a spell slot of 7th or 8th level, the duration is 1 year. When you cast this spell using a spell slot of 9th level, the spell lasts until it is ended by one of the spells mentioned above.',
    ],
    range: '60 feet',
    components: ['V'],
    ritual: false,
    duration: '30 days',
    concentration: false,
    casting_time: '1 minute',
    level: 5,
  },
  {
    index: 'greater-restoration',
    name: 'Greater Restoration',
    url: '/api/spells/greater-restoration',
    shortdesc:
      'You can reduce the target’s exhaustion level by one, or end one effect:',
    desc: [
      "You imbue a creature you touch with positive energy to undo a debilitating effect. You can reduce the target's exhaustion level by one, or end one of the following effects on the target:",
      'One effect that charmed or petrified the target',
      "One curse, including the target's attunement to a cursed magic item",
      "Any reduction to one of the target's ability scores",
      "One effect reducing the target's hit point maximum",
    ],
    range: 'Touch',
    components: ['V', 'S', 'M'],
    material: 'Diamond dust worth at least 100gp, which the spell consumes.',
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 5,
  },
  {
    index: 'insect-plague',
    name: 'Insect Plague',
    url: '/api/spells/insect-plague',
    shortdesc:
      'Creates a sphere of biting locusts that deal damage on anyone inside or entering.',
    desc: [
      "Swarming, biting locusts fill a 20-foot-radius sphere centered on a point you choose within range. The sphere spreads around corners. The sphere remains for the duration, and its area is lightly obscured. The sphere's area is difficult terrain.",
      "When the area appears, each creature in it must make a constitution saving throw. A creature takes 4d10 piercing damage on a failed save, or half as much damage on a successful one. A creature must also make this saving throw when it enters the spell's area for the first time on a turn or ends its turn there.",
    ],
    higher_level: [
      'When you cast this spell using a spell slot of 6th level or higher, the damage increases by 1d10 for each slot level above 5th.',
    ],
    range: '300 feet',
    components: ['V', 'S', 'M'],
    material:
      'A few grains of sugar, some kernels of grain, and a smear of fat.',
    ritual: false,
    duration: 'Up to 10 minutes',
    concentration: true,
    casting_time: '1 action',
    level: 5,
    damage: {
      damage_type: {
        index: 'piercing',
        name: 'Piercing',
        url: '/api/damage-types/piercing',
      },
      damage_at_slot_level: {
        lvl5: '4d10',
        lvl6: '5d10',
        lvl7: '6d10',
        lvl8: '7d10',
        lvl9: '8d10',
      },
    },
    dc: {
      dc_type: {
        index: 'con',
        name: 'CON',
        url: '/api/ability-scores/con',
      },
      dc_success: 'half',
    },
    area_of_effect: {
      type: 'sphere',
      size: 20,
    },
  },
  {
    index: 'mass-cure-wounds',
    name: 'Mass Cure Wounds',
    url: '/api/spells/mass-cure-wounds',
    shortdesc:
      'Up to 6 creatures in a 30 ft sphere heal 3d8+ spellcasting modifier.',
    desc: [
      'A wave of healing energy washes out from a point of your choice within range. Choose up to six creatures in a 30-foot-radius sphere centered on that point. Each target regains hit points equal to 3d8 + your spellcasting ability modifier. This spell has no effect on undead or constructs.',
    ],
    higher_level: [
      'When you cast this spell using a spell slot of 6th level or higher, the healing increases by 1d8 for each slot level above 5th.',
    ],
    range: '60 feet',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 action',
    level: 5,
    attack_type: 'ranged',
    heal_at_slot_level: {
      lvl5: '3d8 + MOD',
      lvl6: '4d8 + MOD',
      lvl7: '5d8 + MOD',
      lvl8: '6d8 + MOD',
      lvl9: '7d8 + MOD',
    },
    area_of_effect: {
      type: 'sphere',
      size: 30,
    },
  },
  {
    index: 'planar-binding',
    name: 'Planar Binding',
    url: '/api/spells/planar-binding',
    shortdesc:
      'You attempt to bind a celestial, an elemental, a fey, or a fiend to your service',
    desc: [
      "With this spell, you attempt to bind a celestial, an elemental, a fey, or a fiend to your service. The creature must be within range for the entire casting of the spell. (Typically, the creature is first summoned into the center of an inverted magic circle in order to keep it trapped while this spell is cast.) At the completion of the casting, the target must make a charisma saving throw. On a failed save, it is bound to serve you for the duration. If the creature was summoned or created by another spell, that spell's duration is extended to match the duration of this spell.",
      'A bound creature must follow your instructions to the best of its ability. You might command the creature to accompany you on an adventure, to guard a location, or to deliver a message. The creature obeys the letter of your instructions, but if the creature is hostile to you, it strives to twist your words to achieve its own objectives. If the creature carries out your instructions completely before the spell ends, it travels to you to report this fact if you are on the same plane of existence. If you are on a different plane of existence, it returns to the place where you bound it and remains there until the spell ends.',
    ],
    higher_level: [
      'When you cast this spell using a spell slot of a higher level, the duration increases to 10 days with a 6th-level slot, to 30 days with a 7th-level slot, to 180 days with an 8th-level slot, and to a year and a day with a 9th-level spell slot.',
    ],
    range: '60 feet',
    components: ['V', 'S', 'M'],
    material: 'A jewel worth at least 1,000 gp, which the spell consumes.',
    ritual: false,
    duration: '24 hours',
    concentration: false,
    casting_time: '1 hour',
    level: 5,
    dc: {
      dc_type: {
        index: 'cha',
        name: 'CHA',
        url: '/api/ability-scores/cha',
      },
      dc_success: 'none',
    },
  },
  {
    index: 'reincarnate',
    name: 'Reincarnate',
    url: '/api/spells/reincarnate',
    shortdesc:
      'Brings a dead person back to life if it has been dead less than 10 days',
    desc: [
      "You touch a dead humanoid or a piece of a dead humanoid. Provided that the creature has been dead no longer than 10 days, the spell forms a new adult body for it and then calls the soul to enter that body. If the target's soul isn't free or willing to do so, the spell fails.",
      "The magic fashions a new body for the creature to inhabit, which likely causes the creature's race to change. The DM rolls a d 100 and consults the following table to determine what form the creature takes when restored to life, or the DM chooses a form.",
      '01-04 Dragonborn',
      '05-13 Dwarf, hill',
      '14-21  Dwarf, mountain',
      '22-25 Elf, dark',
      '26-34 Elf, high',
      '35-42 Elf, wood',
      '43-46 Gnome, forest',
      '47-52 Gnome, rock',
      '53-56 Half-elf',
      '57-60 Half-orc',
      '61-68 Halfling, lightfoot',
      '69-76 Halfling, stout',
      '77-96 Human',
      '97-00 Tiefling',
      'The reincarnated creature recalls its former life and experiences. It retains the capabilities it had in its original form, except it exchanges its original race for the new one and changes its racial traits accordingly.',
    ],
    range: 'Touch',
    components: ['V', 'S', 'M'],
    material:
      'Rare oils and unguents worth at least 1,000 gp, which the spell consumes.',
    ritual: false,
    duration: 'Instantaneous',
    concentration: false,
    casting_time: '1 hour',
    level: 5,
  },
  {
    index: 'scrying',
    name: 'Scrying',
    url: '/api/spells/scrying',
    shortdesc:
      'You can see and hear a particular creature you choose that is on the same plane of existence as you. ',
    desc: [
      "You can see and hear a particular creature you choose that is on the same plane of existence as you. The target must make a wisdom saving throw, which is modified by how well you know the target and the sort of physical connection you have to it. If a target knows you're casting this spell, it can fail the saving throw voluntarily if it wants to be observed.",
      'Knowledge & Save Modifier',
      'Secondhand (you have heard of the target) +5',
      'Firsthand (you have met the target) +0',
      'Familiar (you know the target well) -5',
      'Connection & Save Modifier',
      'Likeness or picture -2',
      'Possession or garment -4',
      'Body part, lock of hair, bit of nail, or the like -10',
      "On a successful save, the target isn't affected, and you can't use this spell against it again for 24 hours.",
      'On a failed save, the spell creates an invisible sensor within 10 feet of the target. You can see and hear through the sensor as if you were there. The sensor moves with the target, remaining within 10 feet of it for the duration. A creature that can see invisible objects sees the sensor as a luminous orb about the size of your fist.',
      "Instead of targeting a creature, you can choose a location you have seen before as the target of this spell. When you do, the sensor appears at that location and doesn't move.",
    ],
    range: 'Self',
    components: ['V', 'S', 'M'],
    material:
      'A focus worth at least 1,000 gp, such as a crystal ball, a silver mirror, or a font filled with holy water.',
    ritual: false,
    duration: 'Up to 10 minutes',
    concentration: true,
    casting_time: '10 minutes',
    level: 5,
    dc: {
      dc_type: {
        index: 'wis',
        name: 'WIS',
        url: '/api/ability-scores/wis',
      },
      dc_success: 'none',
    },
  },
  {
    index: 'tree-stride',
    name: 'Tree Stride',
    url: '/api/spells/tree-stride',
    shortdesc:
      'You can enter a tree and move from inside it to inside another tree of the same kind. ',
    desc: [
      "You gain the ability to enter a tree and move from inside it to inside another tree of the same kind within 500 feet. Both trees must be living and at least the same size as you. You must use 5 feet of movement to enter a tree. You instantly know the location of all other trees of the same kind within 500 feet and, as part of the move used to enter the tree, can either pass into one of those trees or step out of the tree you're in. You appear in a spot of your choice within 5 feet of the destination tree, using another 5 feet of movement. If you have no movement left, you appear within 5 feet of the tree you entered.",
      'You can use this transportation ability once per round for the duration. You must end each turn outside a tree.',
    ],
    range: 'Self',
    components: ['V', 'S'],
    ritual: false,
    duration: 'Up to 1 minute',
    concentration: true,
    casting_time: '1 action',
    level: 5,
  },
  {
    index: 'wall-of-stone',
    name: 'Wall of Stone',
    url: '/api/spells/wall-of-stone',
    shortdesc: 'Creates a stone wall that can be shaped.',
    desc: [
      'A nonmagical wall of solid stone springs into existence at a point you choose within range. The wall is 6 inches thick and is composed of ten 10-foot-by-10-foot panels. Each panel must be contiguous with at least one other panel. Alternatively, you can create 10-foot-by-20-foot panels that are only 3 inches thick.',
      "If the wall cuts through a creature's space when it appears, the creature is pushed to one side of the wall (your choice). If a creature would be surrounded on all sides by the wall (or the wall and another solid surface), that creature can make a dexterity saving throw. On a success, it can use its reaction to move up to its speed so that it is no longer enclosed by the wall.",
      "The wall can have any shape you desire, though it can't occupy the same space as a creature or object. The wall doesn't need to be vertical or rest on any firm foundation. It must, however, merge with and be solidly supported by existing stone. Thus, you can use this spell to bridge a chasm or create a ramp.",
      'If you create a span greater than 20 feet in length, you must halve the size of each panel to create supports. You can crudely shape the wall to create crenellations, battlements, and so on.',
      "The wall is an object made of stone that can be damaged and thus breached. Each panel has AC 15 and 30 hit points per inch of thickness. Reducing a panel to 0 hit points destroys it and might cause connected panels to collapse at the DM's discretion.",
      "If you maintain your concentration on this spell for its whole duration, the wall becomes permanent and can't be dispelled. Otherwise, the wall disappears when the spell ends.",
    ],
    range: '120 feet',
    components: ['V', 'S', 'M'],
    material: 'A small block of granite.',
    ritual: false,
    duration: 'Up to 10 minutes',
    concentration: true,
    casting_time: '1 action',
    level: 5,
  },
];

export default spellsLVL5;
